module.exports = __webpack_public_path__ + "img/1-34-7.060c79db.png";